/**
 * Gọi / nhắn SAPA ở mọi lúc (đợt 3 · 3.2) — phần chọn số, thuần.
 *
 * Nguồn số: `GET /v1/public/ho-tro` (máy chủ đọc `SAPA_HO_TRO_SDT`); thiếu / lỗi / chưa kịp hỏi thì dùng
 * `SDT_HO_TRO` đã nằm sẵn trong mã — nên khi mất mạng vẫn có số để đọc và gọi.
 */
import { SDT_HO_TRO } from '@sapa/shared'
import type { HoTro } from './api.ts'

export interface LienHeSapa {
  /** Số để đọc, như "0987 939 605" — tablet không gọi được thì vẫn đọc ra bấm máy khác. */
  hien: string
  /** `tel:` để bấm gọi. */
  goi: string
  /** Link nhắn Zalo cho SAPA. */
  zalo: string
}

const CHI_SO = /\D/g
const LINK_ZALO = /^https:\/\/zalo\.me\/[A-Za-z0-9._-]+$/

function laSoDung(gon: string): boolean {
  return gon.length >= 8 && gon.length <= 15
}

export function chonLienHeSapa(h: HoTro | null | undefined): LienHeSapa {
  const tuMayChu = h?.sdt?.trim() ?? ''
  const gonMayChu = tuMayChu.replace(CHI_SO, '')
  const hien = laSoDung(gonMayChu) ? tuMayChu : SDT_HO_TRO
  const gon = hien.replace(CHI_SO, '')
  // Link do máy chủ gửi chỉ nhận đúng dạng https://zalo.me/… (không dựng href từ chuỗi lạ).
  const linkMayChu = h?.zalo ?? null
  const zalo =
    linkMayChu !== null && LINK_ZALO.test(linkMayChu) ? linkMayChu : `https://zalo.me/${gon}`
  return { hien, goi: `tel:${gon}`, zalo }
}
